<template>
  <div class="agreement-container">
    <h2>Arnergy General Terms and Conditions with Outright Sales Customers</h2>
    <div class="terms-and-condition" v-if="agreementCount">
      <div class="column1">
        <p class="top-level">
          In these terms and conditions (the “Terms”), “Arnergy” means Arnergy
          Solar Limited and the “Purchaser” means you the Purchaser. Arnergy and
          the Purchaser are also individually referred to as a Party and
          collectively referred to as the Parties. Please read the following
          terms before proceeding with your payment. By clicking register, the
          Purchaser agrees to be bound by these Terms and the Terms contained
          herein and any terms made available via a hyperlink shall constitute
          an outright sales agreement between Arnergy and the Purchaser. By
          choosing to purchase an Arnergy solar power system (the System) under
          the outright-sales model, the Purchaser agrees to provide the required
          documentation for Arnergy’s customer onboarding requirements and the
          Purchaser agrees to be bound by these Terms.
        </p>
        <p class="top-level">
          Be rest assured that all information provided is treated as
          confidential. See clause 9 (Confidentiality). Arnergy reserves the
          right to modify these Terms at any time. Arnergy shall provide the
          Purchaser with notice of the modifications via email communication at
          least five (5) days before the date they become effective.
        </p>

          <p class="main-title">1. Nature of the Terms</p>
        <p class="sub-title">
          The Parties agree that Arnergy shall sell the System to the Purchaser
          in consideration of the payment of the Purchase Price.
        </p>

          <p class="main-title">2. Delivery and Installation</p>
        <p class="sub-title">
          a. Upon completion of the delivery and installation of the System at
          the agreed location (the Site) by Arnergy (the Delivery Date), the
          Purchaser shall deliver to Arnergy the certificate of acceptance.
        </p>
        <p class="sub-title">
          b. Arnergy’s scope of work for the installation includes the
          following:
        </p>
        <p class="sub-sub-title">
          Installation of the solar panels on the roof or a location provided by
          the Purchaser (where applicable);
        </p>
        <p class="sub-sub-title">
          Installation of the bluebox at the Purchaser’s preferred location
          which must be well ventilated, covered from rainfall or water; and
        </p>
        <p class="sub-sub-title">
          Connection of the agreed loads and segregation at the distribution
          box.
        </p>
        <p class="sub-title">
          c. It is agreed and acknowledged that, Arnergy’s scope of work for the
          installation does not include the following:
        </p>
        <p class="sub-sub-title">
          Rewiring of the Purchaser's facility where the wiring architecture of
          the building is a surface wiring; and
        </p>
        <p class="sub-sub-title">
          Interconnection of multiple buildings where the buildings electrical
          wiring are not interconnected.
        </p>
        <p class="sub-sub-title">
          For the out of scope work set out above, the Purchaser shall be
          responsible for the associated work required for the successful
          completion of the installation and the fees.
        </p>

          <p class="main-title">3. Title to the System and Risk</p>
        <p class="sub-title">
          Title to the System shall not pass to the Purchaser until the date
          that the full Purchase Price has been paid to Arnergy (the Payment
          Date). Until the Payment Date, ownership shall not pass to the
          Purchaser and the Purchaser shall not be entitled to sell, transfer,
          lease, charge, assign by way of security or otherwise deal in or
          encumber the System and the relationship between Arnergy and the
          Purchaser in respect of the System including any proceeds of sale or
          other consideration therefore shall be a fiduciary one. The Purchaser
          shall be responsible for physical security of the System from the
          Delivery Date. Risk in the System shall pass to the Purchaser from the
          Delivery Date.
        </p>

          <p class="main-title">4. Purchase Price</p>
        <p class="sub-title">
          a. The Purchase Price is payable in accordance with the following
          milestones:
        </p>
        <p class="sub-sub-title">
          90% of the Purchase Price is payable upfront prior to installation of
          the System; and
        </p>
        <p class="sub-sub-title">
          10% of the Purchase Price is due and payable within fourteen (14) days
          of completion of the installation of the System.
        </p>
        <p class="sub-title">
          b. The Purchaser may also opt to make 100% full payment of the
          Purchase Price prior to installation of the System.
        </p>
        <p class="sub-title">
          c. The Purchase Price is inclusive of the following: (i) the cost of
          delivery of the System to the Site; (ii)Design, Project Management and
          Labour Cost; and (iii) One Year Free Maintenance from the Delivery
          Date.
        </p>

          <p class="main-title">5. Warranty</p>
        <p class="sub-title">
          a. Arnergy warrants that (i) the System is free from defects in
          materials and workmanship for a period of five (5) years from the date
          of installation; and (ii) it will perform the services with reasonable
          care and skill. The Purchaser shall give notice to Arnergy as soon as
          it is reasonably able upon becoming aware of a breach of warranty.
          Arnergy shall as soon as it is reasonably able investigate any alleged
          breach of warranty and in the case of a breach of warranty falling
          within this paragraph shall remedy the same free of charge by: (i)
          carrying out such repairs, modifications or alterations to the System;
          and/or (ii) replacing the System or such component parts as it shall
          in its absolute discretion think fit. The obligations of Arnergy above
          shall be discharged between the hours of 9 am to 5.30 pm Monday to
          Friday (bank and other public holidays excepted). Any System or
          component parts of the System retrieved by Arnergy pursuant to this
          paragraph (the “Retrieved System”) shall upon its replacement with a
          substituted system or component part become the property of Arnergy
          and the Purchaser warrants that its title to such Retrieved System
          shall be free and unencumbered or that it shall have all necessary
          consents and authorities to part with possession of the Retrieved
          System. For the avoidance of doubt it is hereby stated that the term
          "Retrieved System" refers to a defective removed, recovered and
          retrieved System/component parts and not to a new System/component
          parts installed or fitted under this warranty clause.
        </p>
        <p class="sub-title">
          b. Subject to clause (a) above and with the exception of the condition
          and warranties implied by law, all other conditions, warranties, terms
          and undertakings, express or implied, statutory or otherwise in
          respect of the System and the provision of the services are hereby
          excluded.
        </p>

        <p class="main-title">6. Access to the Site</p>
        <p class="sub-sub-title">
          The Purchaser shall allow Arnergy and its designated personnel such
          reasonable access to the Site as it shall from time to time require to
          perform its obligations under these Terms.
        </p>

        <p class="main-title">7. Default</p>
        <p class="sub-title">
          a. Where the Purchaser fails to pay any sum due to Arnergy by the
          stipulated payment dates (Payment Default), Arnergy may suspend part
          or all of the services until the Purchaser makes payment of the
          outstanding payment due to Arnergy.
        </p>
        <p class="sub-title">
          b. Where the outstanding balance payment remains unpaid for a period
          of thirty (30) days after the stipulated payment date, Arnergy
          reserves the right to report the default to the national credit bureau
          and Arnergy can also provide information required to the credit bureau
          with regards to these Terms.
        </p>

        <p class="main-title">8. Termination</p>
        <p class="sub-sub-title">
          These Terms may be terminated by Arnergy in the following instances:
          (i) where there is an unauthorized tampering or hacking of the System
          by the Purchaser after a service suspension/System switch-off by
          Arnergy; or (ii) where a Payment Default subsists for a period of
          thirty (30) days after the installation date.
        </p>
        <p class="sub-sub-title">
          The Purchaser hereby irrevocably authorises Arnergy and its designated
          personnel to access the Site to decommission the System. The
          decommissioning costs shall be payable by the Purchaser and 80% of the
          Purchase Price shall be non-refundable.
        </p>

        <p class="main-title">9. Confidentiality</p>
        <p class="sub-title">
          a. Each Party shall safeguard, treat as confidential and not use for
          the purposes of its own business any Confidential Information
          (information of commercial value of a Party) which relates to the
          business and affairs of either Party. Notwithstanding the above , each
          Party may at any time disclose any Confidential Information, following
          reasonable consultation with the other Party, if the disclosure is
          made in good faith in the circumstances set out below and, in each
          case, only to the extent reasonably necessary: (i) if if it is
          required by law, the terms of a grant, a court of competent
          jurisdiction or any government or regulatory authority; or (ii) to its
          own employees, directors or consultants where such disclosure is
          required for the exercise of the relevant Party’s obligations under
          these Terms.
        </p>
        <p class="sub-title">
          b. In the case of a company, the Purchaser hereby grants Arnergy the
          right to use the name and service marks of the Purchaser in its
          marketing materials or other oral, electronic, or written promotions,
          which shall include naming the Purchaser as a client of Arnergy and a
          brief scope of services provided. Either Party may elect to issue a
          press or social media promotional release related to these Terms. In
          doing so, any release shall be approved by the other Party and such
          approval shall not be unreasonably withheld.
        </p>

        <p class="main-title">10. Miscellaneous</p>
        <p class="sub-title">
          a. Variation- No variation of these Terms shall be effective unless it
          is in writing and signed by the Parties or their authorized
          representatives.
        </p>
        <p class="sub-title">
          b. Severability- In the event any provision of these Terms is
          determined to be invalid or unenforceable by ruling of an arbitrator
          or court of competent jurisdiction, the remainder of these Terms (and
          each of the remaining terms and conditions contained herein) shall
          remain in full force and effect.
        </p>
        <p class="sub-sub-title">
          No Assignment- Neither these Terms nor any of the rights of a Party
          herein may be assigned, pledged, transferred or hypothecated without
          the prior written consent of the other Party.
        </p>
        <p class="sub-sub-title">
          Force Majeure- If a Party is prevented from fulfilling its obligations
          under these Terms by reason of any supervening event beyond its
          control (including but not limited to an Act of God, Natural Disaster,
          Pandemic or Epidemic or Civil Disorder), the Party unable to fulfil
          its obligations shall immediately give notice in writing of this to
          the other Party and shall do everything in its power, including but
          not limited to accepting assistance from third parties or the other
          Party, to resume full performance. If the period of incapacity exceeds
          thirty (30) days , then these Terms shall also automatically terminate
          unless Parties expressly agree otherwise in writing. The Parties shall
          be relieved from liability under these Terms, except in relation to
          obligations to make payments which fall due under these Terms.
        </p>
        <p class="sub-sub-title">
          Entire Agreement- these Terms shall constitute the entire agreement of
          the Parties with respect to the subject matter herein, and shall
          supersede all other prior agreements, understandings, and
          negotiations, both written and oral, between the Parties hereto.
        </p>

        <p class="main-title">11. Governing Law and Dispute Resolution</p>
        <p class="sub-sub-title">
          These Terms shall be governed by and construed in accordance with the
          laws of the Federal Republic of Nigeria. The Parties shall endeavour
          in good faith to resolve any such dispute through amicable discussion
          within a period of thirty (30) days commencing on the date either
          Party serves written notice upon the other outlining the nature and
          substance of such dispute. Where the Parties are unable to amicably
          settle the dispute within the thirty (30) day period, such dispute
          shall be submitted by either or both Parties to arbitration at the
          Lagos Multi-Door Courthouse.
        </p>

        <p class="main-title">12. Authority</p>
        <p class="sub-sub-title">
          In the case of a company as the Purchaser, the individual that has
          agreed electronically with these Terms for their respective company
          warrants that they are fully authorized to do so and that they (and
          their respective company) are thereby legally bound by all of the
          terms and conditions hereof.
        </p>
      </div>
    </div>
    <div class="below-agreement">
      <div class="accept-terms" @click="toggleAgreementCheck">
        <span class="green-box">
          <svg
            v-if="checkAgreement"
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.7586 2.00489C13.0804 2.34979 13.0804 2.89737 12.7586 3.24227L5.52359 10.9952C5.33629 11.196 5.07182 11.2919 4.80879 11.2611C4.56725 11.2703 4.33131 11.1737 4.16035 10.9905L0.241389 6.79096C-0.0804629 6.44606 -0.0804629 5.89847 0.241389 5.55358C0.579197 5.19159 1.14011 5.19159 1.47791 5.55357L4.8441 9.16052L11.5221 2.00489C11.8599 1.6429 12.4208 1.6429 12.7586 2.00489Z"
              fill="white"
            />
          </svg>
        </span>
        <small>Click to Accept Terms and Regulations</small>
      </div>
      <div class="terms-pagination">
        <div
          class="button left-btn"
          @click="handleAgreementNavigation('minus')"
        >
          <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z"
              fill="#0892D0"
            />
          </svg>
        </div>
        <div
          class="button right-btn"
          @click="handleAgreementNavigation('plus')"
        >
          <svg
            width="7"
            height="8"
            viewBox="0 0 7 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.448125 7.872L4.03212 4.256L0.448125 0.655999H3.02413L6.60813 4.256L3.02413 7.872H0.448125Z"
              fill="#0892D0"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OSAgreement",
  props: [ "updateStatus", "updateAgreementStatus", "updateTracker" ],
  data() {
    return {
      checkAgreement: false,
      agreementCount: 1,
    };
  },
  methods: {
    toggleAgreementCheck() {
      this.checkAgreement = !this.checkAgreement;
      this.updateAgreementStatus(this.checkAgreement);
    },
    handleAgreementNavigation(direction) {
      if (this.agreementCount >= 0) {
        if (direction === "plus") this.agreementCount = this.agreementCount + 1;
        if (direction === "minus")
          this.agreementCount = this.agreementCount - 1;
      }
    },
  },
  mounted() {
    this.updateTracker(true);
    this.updateStatus(1);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.agreement-container {
  display: flex;
  flex-direction: column;
}

.terms-and-condition,
.terms-pagination,
.below-agreement {
  display: flex;
}

.terms-and-condition {
  justify-content: space-between;
  height: 56vh;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;

  > div {
    width: 52%;
    height: 47.5vh;
    /* margin-right: 4rem; */

    p {
      margin-right: 5rem;
    }
  }

  .main-title {
    color: #000000;
  }

  .sub-sub-title {
    text-indent: 20px;
  }

  .column1 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.green-box {
  width: 20px;
  height: 20px;
  background: #4aeb76;
}

.accept-terms {
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  small {
    color: #727272;
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
    display: inline-block;
    margin-left: 12px;
  }
}

.below-agreement {
  justify-content: space-between;
  align-items: center;
}

.terms-pagination .button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
  cursor: pointer;

  &:first-child {
    margin-right: 5px;
  }
}

.top-level {
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/outrightSale/OSAgreement.vue